/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPayorSourceSummary
 */
export interface HchbPayorSourceSummary {
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    service_line_type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HchbPayorSourceSummary
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HchbPayorSourceSummary
     */
    use_physician_medicaid_no: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HchbPayorSourceSummary
     */
    frequently_used: boolean;
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPayorSourceSummary
     */
    phone?: string;
}

/**
 * Check if a given object implements the HchbPayorSourceSummary interface.
 */
export function instanceOfHchbPayorSourceSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "use_physician_medicaid_no" in value;
    isInstance = isInstance && "frequently_used" in value;

    return isInstance;
}

export function HchbPayorSourceSummaryFromJSON(json: any): HchbPayorSourceSummary {
    return HchbPayorSourceSummaryFromJSONTyped(json, false);
}

export function HchbPayorSourceSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPayorSourceSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'service_line_type': !exists(json, 'service_line_type') ? undefined : json['service_line_type'],
        'active': json['active'],
        'use_physician_medicaid_no': json['use_physician_medicaid_no'],
        'frequently_used': json['frequently_used'],
        'street': !exists(json, 'street') ? undefined : json['street'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}

export function HchbPayorSourceSummaryToJSON(value?: HchbPayorSourceSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'service_line_type': value.service_line_type,
        'active': value.active,
        'use_physician_medicaid_no': value.use_physician_medicaid_no,
        'frequently_used': value.frequently_used,
        'street': value.street,
        'city': value.city,
        'state': value.state,
        'zip': value.zip,
        'phone': value.phone,
    };
}

